import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

export const BulletList = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function BulletList({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M3.95834 5.20833C4.53363 5.20833 5.00001 4.74196 5.00001 4.16667C5.00001 3.59137 4.53363 3.125 3.95834 3.125C3.38304 3.125 2.91667 3.59137 2.91667 4.16667C2.91667 4.74196 3.38304 5.20833 3.95834 5.20833Z'
        fill={color}
      />
      <path
        d='M17.5 4.375C17.5 4.60512 17.3135 4.79167 17.0833 4.79167H7.91667C7.68655 4.79167 7.5 4.60512 7.5 4.375V3.95833C7.5 3.72821 7.68655 3.54167 7.91667 3.54167H17.0833C17.3135 3.54167 17.5 3.72821 17.5 3.95833V4.375Z'
        fill={color}
      />
      <path
        d='M17.5 10.2083C17.5 10.4385 17.3135 10.625 17.0833 10.625H7.91667C7.68655 10.625 7.5 10.4385 7.5 10.2083V9.79167C7.5 9.56155 7.68655 9.375 7.91667 9.375H17.0833C17.3135 9.375 17.5 9.56155 17.5 9.79167V10.2083Z'
        fill={color}
      />
      <path
        d='M17.0833 16.4583C17.3135 16.4583 17.5 16.2718 17.5 16.0417V15.625C17.5 15.3949 17.3135 15.2083 17.0833 15.2083H7.91667C7.68655 15.2083 7.5 15.3949 7.5 15.625V16.0417C7.5 16.2718 7.68655 16.4583 7.91667 16.4583H17.0833Z'
        fill={color}
      />
      <path
        d='M5.00001 10C5.00001 10.5753 4.53363 11.0417 3.95834 11.0417C3.38304 11.0417 2.91667 10.5753 2.91667 10C2.91667 9.4247 3.38304 8.95833 3.95834 8.95833C4.53363 8.95833 5.00001 9.4247 5.00001 10Z'
        fill={color}
      />
      <path
        d='M3.95834 16.875C4.53363 16.875 5.00001 16.4086 5.00001 15.8333C5.00001 15.258 4.53363 14.7917 3.95834 14.7917C3.38304 14.7917 2.91667 15.258 2.91667 15.8333C2.91667 16.4086 3.38304 16.875 3.95834 16.875Z'
        fill={color}
      />
    </>
  ));
  return (
    <BaseComponent viewBox='0 0 20 20' ref={ref} dataTestId={dataTestId ?? 'bullet-list-icon-svg'} iconRender={iconRender} {...props} />
  );
});
